import { render, staticRenderFns } from "./AiMedicalRecordsViewDialog.vue?vue&type=template&id=a5350e78&scoped=true&"
import script from "./AiMedicalRecordsViewDialog.vue?vue&type=script&lang=ts&"
export * from "./AiMedicalRecordsViewDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AiMedicalRecordsViewDialog.vue?vue&type=style&index=0&id=a5350e78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5350e78",
  null
  
)

export default component.exports